module.exports = __webpack_public_path__ + "static/media/job_category_26.1f4fd3ee.png";